module.exports = __webpack_public_path__ + "img/full7-min.46cd0cbd.png";